import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke391aRequest, Sgke391aResponse, Sgke391aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke391aService {
  /**
   * コンストラクタ
   * @param {Sgke391aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke391aService
   */
  constructor(
    public service: Sgke391aService,
    public apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }
  /**
   * SGKE391A_供給先関連情報画面初期表示API呼び出し
   * @param {Sgke391aRequest} request 
   * @returns {Observable<Sgke391aResponse>}
   * @memberof UsedSgke391aService
   */
  public doSgke391a(request: Sgke391aRequest): Observable<Sgke391aResponse> {
    return this.service.SGKE391APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE391A');
          return throwError(err.message);
        })
      );
  }
}
